/*@ngInject*/
const UISnippetsViewerResizableDirective = function ($document, $window, $timeout, $stateParams, submissionStateMediator) {

    var linkFunction = function ($scope, $elm, $attrs) {

        var opt = {
            handle: '.snippetsViewerHeader',
            draggableClass: 'resizable'
        };

        var $resizer = $('<div class="resizer" />').appendTo($elm),
            startX, startY, startWidth, startHeight, lastSavedSize = {};

        var saveState = function () {
            var currentState = submissionStateMediator.getSnippetsViewerPositionState($stateParams.submissionId) || {};

            currentState = _.extend(currentState, lastSavedSize);

            submissionStateMediator.saveSnippetsViewerPositionState($stateParams.submissionId, currentState);
        };

        var restoreState = function () {
            var currentState = submissionStateMediator.getSnippetsViewerPositionState($stateParams.submissionId) || {};

            lastSavedSize = {
                width: _.get(currentState, 'width', ''),
                height: _.get(currentState, 'height', '')
            };
        };

        var startDrag = function (e) {
            startX = e.clientX;
            startY = e.clientY;

            startWidth = $($elm).width();
            startHeight = $($elm).height();

            if (!$scope.$ctrl.isDetached) {
                return; // do nothing
            }

            $document.on('mousemove', doDrag);
            $document.on('mouseup', endDrag);
        };

        var endDrag = function (e) {
            $document.off('mousemove', doDrag);
            $document.off('mouseup', endDrag);

            saveState();
        };

        var doDrag = function (e) {
            var newWidth = (startWidth + e.clientX - startX) + 'px';
            var newHeight = (startHeight + e.clientY - startY) + 'px';
            $elm.css({width: newWidth, height: newHeight});
            lastSavedSize.width = newWidth;
            lastSavedSize.height = newHeight;
        };

        $resizer.on('mousedown', startDrag);

        $scope.$watch('$ctrl.isDetached', function (newValue) {
            if (newValue) {
                if (!_.isEmpty(lastSavedSize)) {
                    $elm.css({'width': lastSavedSize.width, 'height': lastSavedSize.height});
                }
            } else {
                $elm.css({'width': '', 'height': ''});
            }
        });

        $scope.$on('$destroy', function () {
            $resizer.off('mousedown', startDrag);
        });

        restoreState();
    };

    return {
        restrict: 'A',
        replace: false,
        link: linkFunction
    };
};

angular.module('gw-um-submission')
    .directive('uiSnippetsViewerResizable', UISnippetsViewerResizableDirective);
